<div class="card border-0 shadow-sm detail-card" *ngIf="message">
  <!-- Header avec actions -->
  <div class="card-header bg-white border-bottom">
    <div class="d-flex justify-content-between align-items-center">
      <button type="button" class="btn btn-sm btn-outline-secondary btn-back" (click)="onBack()">
        <i class="feather icon-arrow-left mr-1"></i> Retour
      </button>
      <div>
        <button type="button" class="btn btn-sm btn-outline-primary mr-2 btn-detail-action" tooltip="Renvoyer" (click)="onResend()">
          <i class="fas fa-redo mr-1"></i> Renvoyer
        </button>
        <button type="button" class="btn btn-sm btn-outline-danger btn-detail-action" tooltip="Corbeille" (click)="onMoveToTrash()">
          <i class="feather icon-trash-2 mr-1"></i> Corbeille
        </button>
      </div>
    </div>
  </div>

  <div class="card-body p-4">
    <!-- En-tete message -->
    <div class="message-header mb-4">
      <div class="d-flex align-items-start justify-content-between">
        <div class="d-flex align-items-center">
          <div class="type-badge mr-3" [ngClass]="{'mail-badge': message?.type === 'MAIL', 'sms-badge': message?.type === 'SMS'}">
            <i [class]="message?.type === 'MAIL' ? 'fas fa-envelope' : 'fas fa-comment-alt'"></i>
          </div>
          <div>
            <h5 class="mb-1 font-weight-bold">
              Detail du {{ typeLabel | lowercase }}
              <span class="text-muted font-weight-normal" style="font-size: 0.85rem;">{{ message?.code }}</span>
            </h5>
            <div class="d-flex align-items-center">
              <span class="badge badge-{{ etatClass }} badge-status mr-2">
                <i class="fas fa-circle mr-1" style="font-size: 0.4rem; vertical-align: middle;"></i>
                {{ etatLabel }}
              </span>
              <span class="text-muted" style="font-size: 0.825rem;">
                <i class="fas fa-calendar-alt mr-1"></i>
                {{ message?.createdAt | date: "d MMMM y 'a' H:mm:ss" : '' : 'fr-FR' }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr class="my-3">

    <!-- Destinataires -->
    <div class="section mb-4">
      <h6 class="section-title">
        <i class="fas fa-users mr-2 text-primary"></i> Destinataire(s)
        <span class="badge badge-primary badge-pill ml-2">{{ message?.destinataire?.length }}</span>
      </h6>
      <div class="recipients-list p-3 rounded">
        <div class="row">
          <div *ngFor="let dest of message?.destinataire" class="col-md-6 mb-1">
            <div class="recipient-item d-flex align-items-center p-2 rounded">
              <i class="fas fa-chevron-right text-primary mr-2" style="font-size: 0.6rem;"></i>
              <span style="font-size: 0.875rem;">{{ dest }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Objet (mail uniquement) -->
    <div *ngIf="message?.type === 'MAIL' && message?.objet" class="section mb-4">
      <h6 class="section-title">
        <i class="fas fa-heading mr-2 text-primary"></i> Objet
      </h6>
      <div class="p-3 bg-light rounded" style="font-size: 0.9rem;">
        {{ message?.objet }}
      </div>
    </div>

    <!-- Contenu -->
    <div class="section">
      <h6 class="section-title">
        <i class="fas fa-align-left mr-2 text-primary"></i> Contenu du message
      </h6>
      <div class="message-content p-3 rounded">
        <div *ngIf="message?.type === 'MAIL'" [innerHTML]="safeContent"></div>
        <div *ngIf="message?.type === 'SMS'" style="white-space: pre-wrap; font-size: 0.9rem;">{{ message?.content }}</div>
      </div>
    </div>
  </div>
</div>
